import React from "react"
import { Collapse, Row } from "reactstrap"
import classnames from "classnames"
// import MobileTableBody from "./mobileTableBody"
import moment from "moment"
import MobileTableBody from "./MobileTableBody"

const MobileView = ({
  sethandleAccordion,
  handleAccordion,
  keyId,
  user_name,
  data,
  activeworkfromhome,
  item
}) => {
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }
  return (
    <React.Fragment>
      <Row>
        <div className="accordion" id="accordion" key={keyId}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingOne">
              <button
                className={classnames(
                  "accordion-button zIndexes zIndexesNo",
                  "fw-medium",
                  {
                    collapsed: handleAccordion !== keyId,
                  }
                )}
                type="button"
                onClick={() => handleOnclickAccordion(keyId)}
                style={{ cursor: "pointer" }}
              >
                {user_name}
              </button>
            </h2>
            <Collapse
              isOpen={handleAccordion === keyId}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted">
                  <div className="text-center d-block mb-2 text-uppercase font-weight-bold">
                    {activeworkfromhome.id === 1 ? 'Detailed Work' : 'Summary of Work'}
                  </div>
                  {/* <Row>
                    <table className="table table-striped">
                      <tbody>
                        <MobileTableBody
                          item={item}
                          hidecolumn={false}
                          activeworkfromhome={activeworkfromhome}
                        />
                      </tbody>
                    </table>
                  </Row> */}
                  {activeworkfromhome?.id === 1 ? <>{data.map((el, index) => (
                    <table className="table table-striped" key={index}>
                      <div className="text-end d-block mb-2 text-uppercase font-weight-bold">
                      </div>
                      <tbody>
                        <MobileTableBody
                          item={el}
                          hidecolumn={true}
                          activeworkfromhome={activeworkfromhome}
                        />
                      </tbody>
                    </table>
                  ))}</> :
                    <table className="table table-striped">
                      <div className="text-end d-block mb-2 text-uppercase font-weight-bold">
                      </div>
                      <tbody>
                        <MobileTableBody
                          item={item}
                          hidecolumn={true}
                          activeworkfromhome={activeworkfromhome}
                        />
                      </tbody>
                    </table>}
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}
export default MobileView
